export default __webpack_public_path__ + "images/4db4c5190b9fefc601e25f3f2968d0cc-baseball.png";